import { addDoc, collection, doc } from "firebase/firestore";
import axios from "axios";
import { db } from "../../../firebase";
import { toast } from "react-hot-toast";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { storage } from "../../../firebase";

// import axios from "axios";
export const createNewVender = async (
  data,
  companyName,
  phNumber,
  mails,
  addresses,
  vendorNotes,
  files
) => {
  const companiesRef = collection(db, "companies");
  const companyDocRef = doc(companiesRef, companyName);
  const vendorRef = collection(companyDocRef, "vendors");
  // const getNotes = JSON.parse(localStorage.getItem("notes"));

  // console.log("Notes");
  // console.log(...getNotes);
  // console.log("Notes");
  try {
    const values = { ...data };
    // It checks the values if undefined it will assign empty value " "
    Object.keys(values).forEach((key) => {
      const value = values[key];
      if (value === undefined) {
        values[key] = "";
        // Convert Date to formatted string
      } else if (value instanceof Date) {
        values[key] = value.format("DD-MM-YYYY");
      }
    });

    const uniqueIds = {}; // Helper object to keep track of seen ids
    const imagesUrl = []; // Helper object to keep track of seen ids
    const uniqueItems = files.filter((item) => {
      // If the id is not in the uniqueIds object, add it and return true
      if (!uniqueIds[item.uid]) {
        uniqueIds[item.uid] = true;
        return true;
      }
      // If the id is already in the uniqueIds object, return false to filter it out
      return false;
    });

    for (const file of uniqueItems) {
      const storageRef = ref(storage, `/files/vendors/${file.name}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      try {
        await uploadTask;

        // File uploaded successfully
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          const fileData = {
            downloadURL: downloadURL,
            id: file.uid,
            name: file.name,
            type: file.type,
            isDefault: false,
          };
          imagesUrl.push(fileData);
        console.log("Download URL for", file.name, ":", downloadURL);
      } catch (error) {
        console.error("Upload error for", file.name, ":", error);
      }
    }

    console.log("files", files);
    console.log("imagesUrlimagesUrlimagesUrl", imagesUrl);

    const vendorCreated = await addDoc(vendorRef, {
      vendorInfo: {
        salutation: values.salutation,
        firstName: values.firstName,
        lastName: values.lastName,
        companyName: values.companyName,
        websiteLink: values.websiteLink,
        vendorType: values.vendorType,
        venderTrade: values.venderTrade,
        isVendorUseForWorkOrder: values.isVendorUseForWorkOrder,
        tags: [...values.tags],
      },

      accountingInfo: {
        consolidateChecks: values.consolidateChecks,
        holdPayments: values.holdPayments,
        checkEmailReceipt: values.checkEmailReceipt,

        defaultCheckMemo: values.defaultCheckMemo,
        paymentTerms: values.paymentTerms,
        workOrderAdjustment: values.workOrderAdjustment,
        adjustmentType: values.adjustmentType,
      },
      federalTax: {
        taxPayerName: values.taxPayerName,
        comapnyTaxpayer: values.comapnyTaxpayer,
        taxPayerId: values.taxPayerId,
        send1099: values.send1099,
      },
      compliance: {
        workerCompExpiration: values["workerCompExpiration"]
          ? values["workerCompExpiration"].format("DD-MM-YYYY")
          : "",
        liabilityInsuranceExpiration: values["liabilityInsuranceExpiration"]
          ? values["liabilityInsuranceExpiration"].format("DD-MM-YYYY")
          : "",
        EPACertificationExpiration: values["EPACertificationExpiration"]
          ? values["EPACertificationExpiration"].format("DD-MM-YYYY")
          : "",
        autoInsuranceExpiration: values["autoInsuranceExpiration"]
          ? values["autoInsuranceExpiration"].format("DD-MM-YYYY")
          : "",
        stateLicenseExpiration: values["stateLicenseExpiration"]
          ? values["stateLicenseExpiration"].format("DD-MM-YYYY")
          : "",
        contractExpiration: values["contractExpiration"]
          ? values["contractExpiration"].format("DD-MM-YYYY")
          : "",
      },
      address1099: {
        ["address1099-1"]: values["address1099-1"] || "",
        ["address1099-2"]: values["address1099-2"] || "",
        city1099: values.city1099 || "",
        state1099: values.state1099 || "",
        zip1099: values.zip1099 || "",
      },
      onlinePaybles: {
        useOnlinePayables: values.useOnlinePayables || "",
        paymentMethod: values.paymentMethod || "",
        vendorBankRoutingNumber: values.vendorBankRoutingNumber || "",
        vendorAccountNumber: values.vendorAccountNumber || "",
        savingAccount: values.savingAccount || "",
      },
      notes: vendorNotes,
      attachments: imagesUrl ? imagesUrl : [],

      contact: {
        phoneNumbers: phNumber,
        emails: mails,
        addresses,
      },
    });
    console.log("IDDDDD", vendorCreated.id);
    if (vendorCreated.id) {
      try {
        const vendorData = {
          email: values.email0,
          firstName: values.firstName,
          lastName: values.lastName,
          role: "vendor",
          companyName: companyName,
          vendorId: vendorCreated.id,
        };
        console.log("database send:", vendorData);
        try {
          const response = await axios.post(
            "https://us-central1-sayeagle-77c75.cloudfunctions.net/api/vendor-user",
            vendorData
          );
          console.log(response.data); // User created successfully
          toast.success("Vendor created successfully");
          // navigate("/");
        } catch (error) {
          console.error("Error creating user:", error);
          const errorMessage = error.message;
          toast.error(errorMessage);
        }
      } catch (error) {
        const errorMessage = error.message;
        toast.error(errorMessage);
      }
    }

    // console.log(values);
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};
